import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../../../../appContext";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Link } from "react-router-dom";
import './lab-choose-generic.css';

const LabChooseGeneric = (
	{
		onSelectLab,
		title,
		subtitle,
		subtitle2,
		CardComponent,
		showPreferidos = false,
		emptyMessage,
		labsList,
		useComplexProps = false,
		showMinhaOticaLink = true,
		labFilterKey = 'Pedido_c'
	}) => {
	const context = useContext(AppContext);
	const [ allLabs, setAllLabs ] = useState([]);
	const [ labs, setLabs ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const [ onlyPreferidos, setOnlyPreferidos ] = useState(false);
	const [ hasPreferidos, setHasPreferidos ] = useState(false);
	const [ allPreferidos, setAllPreferidos ] = useState(false);

	useEffect(() => {
		fetchLabs();
	}, []);

	useEffect(() => {
		filterLabs();
	}, [ onlyPreferidos, allLabs ]);

	const fetchLabs = async () => {
		setLoading(true);
		context.showLoading('Carregando laboratórios...');

		const requestOptions = {
			method: "POST",
			body: JSON.stringify({
				cnpjs: labsList,
				papel: context.userSession.papel,
				conta: context.userSession.conta,
			}),
		};

		try {
			const response = await fetch(process.env.REACT_APP_LABS_API + "get_labs.php", requestOptions);
			const json = await response.json();

			if (json.items) {
				let hasPreferidosFlag = false;
				let onlyPreferidosFlag = false;

				const labsArray = json.items
					.filter(item => item[labFilterKey] === true)
					.map(item => {
						if (!onlyPreferidosFlag && item.IsPreferido) {
							onlyPreferidosFlag = hasPreferidosFlag = true;
						}

						return {
							Id: item.Id,
							nome: item.Nome_c,
							telefone: item.Telefone_c,
							site: item.Site_c,
							email: item.Email_c,
							cnpj: item.CNPJ_c,
							logo: item.URL_Logo_c,
							promo: item.Promocao_c,
							corteRemoto: item.RemoteEdge_c,
							detailOrder: item.DetalhesDoPedido_c,
							IsCor_AR: item.IsCor_AR_c,
							IsGrowmocao: item.Growmocao_c,
							IsPreferido: item.IsPreferido || false,
							colorirNaOtica: item.ColorirNaOtica_c || false,
							CorteMontagemObrigatorio: item.CorteMontagemObrigatorio_c || false,
							IsPacto: item.Pacto_c || false,
							PossuiProgramaFidelidadeProprio_c: item.PossuiProgramaFidelidadeProprio_c || false,
							PactoNovaJornada: item.PactoNovaJornada_c || false,
						};
					});

				const allPreferidosFlag = hasPreferidosFlag &&
					labsArray.length === labsArray.filter(item => item.IsPreferido).length;

				setAllLabs(labsArray);
				setHasPreferidos(hasPreferidosFlag);
				setOnlyPreferidos(showPreferidos ? onlyPreferidosFlag : false);
				setAllPreferidos(allPreferidosFlag);
			}
		} catch (error) {
			console.error('Erro ao buscar laboratórios:', error);
		} finally {
			context.hideLoading();
			setLoading(false);
		}
	};

	const filterLabs = () => {
		let labsAux = [ ...allLabs ].sort((x, y) =>
			x.IsPreferido === y.IsPreferido ? 0 : x.IsPreferido ? -1 : 1
		);

		if (onlyPreferidos && showPreferidos) {
			labsAux = labsAux.filter(item => item.IsPreferido);
		}

		setLabs(labsAux);
	};

	const showAllLabs = () => setOnlyPreferidos(false);
	const hideAllLabs = () => setOnlyPreferidos(true);

	return (
		<div className="row labChooseGrid" style={ { width: "70%", margin: "0 auto" } }>
			<div className="col-12 text-center">
				<h1 className="x-web-ordering__labs--title">{ title }</h1>
				<p className="x-web-ordering__labs--paragraph text-center">
					{ subtitle }
					{ showMinhaOticaLink && context.userSession?.modulos?.includes("Minha Ótica") && (
						<>
							<br/>
							Para configurar seus laboratórios preferenciais,{ " " }
							<Link to="/empresa" className="x-web-ordering__intro--link x-web-ordering__intro--subtitle-bold">
								clique aqui.
							</Link>
						</>
					) }
				</p>
				{ subtitle2 && (
					<p className="x-web-ordering__intro--subtitle2">{ subtitle2 }</p>
				) }
			</div>

			<div className="col-12 mx-auto">
				<div className="row text-center d-flex justify-content-center">
					{ labs.map((lab, index) => (
						<div key={ index } className="col-12 col-sm-6 col-md-4 col-lg-3">
							{ useComplexProps ? (
								<CardComponent
									key={ index }
									link={ lab.link || '/order' }
									logo={ lab.logo }
									labCnpj={ lab.cnpj }
									labName={ lab.nome }
									laboratorio={ lab }
									labId={ lab.Id }
									AllLabs={ labs }
									PossuiProgramaFidelidadeProprio_c={ lab.PossuiProgramaFidelidadeProprio_c }
									telefone={ lab.telefone }
									site={ lab.site }
									email={ lab.email }
									promo={ lab.promo }
									corteRemoto={ lab.corteRemoto }
									detailOrder={ lab.detailOrder }
									IsCor_AR={ lab.IsCor_AR }
									IsGrowmocao={ lab.IsGrowmocao }
									IsPreferido={ lab.IsPreferido }
									CorteMontagemObrigatorio={ lab.CorteMontagemObrigatorio }
									colorirNaOtica={ lab.colorirNaOtica }
									IsPacto={ lab.IsPacto }
									onClick={ () => onSelectLab(lab) }
								/>
							) : (
								<CardComponent
									lab={ lab }
									onClick={ () => onSelectLab(lab) }
								/>
							) }
						</div>
					)) }

					{ labs.length === 0 && !loading && (
						<div className="col-12 text-center">
							<p>{ emptyMessage }</p>
						</div>
					) }
				</div>

				{ showPreferidos && hasPreferidos && !allPreferidos && (
					<div className="labChooseToggle">
						{ onlyPreferidos ? (
							<a id="lab-toggle-all" className="labChooseToggle__btn" onClick={ showAllLabs }>
								<ExpandMoreIcon className="labChooseToggle__icon" />
								<span>Ver todos os laboratórios</span>
							</a>
						) : (
							<a id="lab-toggle-preferred" className="labChooseToggle__btn" onClick={ hideAllLabs }>
								<ExpandLessIcon className="labChooseToggle__icon" />
								<span>Ver apenas preferidos</span>
							</a>
						) }
					</div>
				) }
			</div>
		</div>
	);
};

export default LabChooseGeneric;